import React from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-page">
      <section className="privacy-hero">
        <div className="container">
          <h1>Privacy Policy</h1>
          <p className="last-updated">Last Updated: January 22, 2026</p>
        </div>
      </section>

      <div className="privacy-content">
        <section className="privacy-section">
          <p>
              This Privacy Policy explains how <strong>MunchUps (NordicBloom AB)</strong> ("we", "us", "our") collects, uses, stores,
              and protects your personal data when you interact with us, purchase our products, or otherwise use our services.
            </p>
            <p>
              We sell <strong>imported packaged snacks originating from countries outside the European Union</strong>. While our products are sourced 
              internationally, we are committed to protecting your personal data in accordance with applicable data protection laws, 
              including the <strong>EU General Data Protection Regulation (GDPR)</strong> where applicable.
            </p>
        </section>
        <section className="privacy-section">
          <h2>1. Introduction & Who We Are</h2>
            <p>
              <strong>Company Name:</strong> MunchUps (NordicBloom AB)<br />
              <strong>Registered Address:</strong> Näsbydalsvägen 6, Täby 183 31, Sweden<br />
              <strong>Email:</strong> <a href="mailto:info.munchups@gmail.com">info.munchups@gmail.com</a> <br />
              <strong>Phone:</strong> +46769092146
            </p>
            <p>
              For the purposes of data protection law, <strong>MunchUps (NordicBloom AB)</strong> is the data controller of your personal data.
            </p>
        </section>
        <section className="privacy-section">
          <h2>2. What Personal Information We Collect</h2>
            <p>
              We may collect and process the following categories of personal data:
            </p>
            <h3>2.1 Information You Provide to Us</h3>
            <ul>
              <li>Name</li>
              <li>Billing and delivery address</li>
              <li>Email address</li>
              <li>Phone Number</li>
              <li>Payment-related information (processed securely by third-party payment providers; we do not store full card details)</li>
              <li>Account information (if you create an account)</li>
              <li>Communications with us (emails, contact forms, customer support messages)</li>
            </ul>
        </section>
        <section className="privacy-section">
          <h2>3. How We Use Your Personal Data</h2>
            <p>
              We use your personal data for the following purposes:
            </p>
            <ul>
              <li>To process and fulfill orders</li>
              <li>To arrange shipping and delivery</li>
              <li>To manage payments and prevent fraud</li>
              <li>To communicate with you about your orders or inquiries</li>
              <li>To comply with legal and regulatory obligations</li>
              <li>To improve our website, products, and customer experience</li>
              <li>To send marketing communications (only where you have given consent or where permitted by law)</li>
            </ul>
        </section>
        <section className="privacy-section">
          <h2>4. Legal Basis for Processing</h2>
            <p>
              Under the GDPR, we rely on the following legal bases to process your personal data:
            </p>
            <ul>
              <li><strong>Contract Performance:</strong> To process and deliver your orders</li>
              <li><strong>Legal Obligation:</strong> To comply with tax, customs, and consumer laws</li>
              <li><strong>Legitimate Interest:</strong> To operate and improve our business, prevent fraud, and ensure security</li>
              <li><strong>Consent:</strong> For marketing communications and non-essential cookies (where required)</li>
            </ul>
        </section>
        <section className="privacy-section">
          <h2>5. Sharing Your Personal Data</h2>
            <p>
              We may share your personal data with trusted third parties, including:
            </p>
            <ul>
              <li>Payment service providers</li>
              <li>Accounting, legal, and professional advisors</li>
              <li>Government or regulatory authorities (where required by law)</li>
              </ul>
            <p>
              All third parties are required to process your data securely and only for specified purposes.
            </p>
        </section>
        <section className="privacy-section">
          <h2>6. Data Retention</h2>
            <p>
              We retain your personal data only for as long as necessary to:
            </p>
           <ul>
              <li>Fulfill the purposes described in this policy</li>
              <li>Comply with legal, tax, and accounting obligations</li>
              <li>Resolve disputes and enforce agreements</li>
            </ul>
            <p>
              When data is no longer required, it is securely deleted or anonymized.
            </p>
        </section>
        <section className="privacy-section">
          <h2>7. Your Data Protection Rights</h2>
            <p>
              If you are located in the EU/EEA, you have the following rights under GDPR:
            </p>
            <ul>
              <li>Right to access your personal data</li>
              <li>Right to rectification of inaccurate or incomplete data</li>
              <li>Right to erasure ("right to be forgotten")</li>
              <li>Right to restrict processing</li>
              <li>Right to data portability</li>
              <li>Right to object to processing</li>
              <li>Right to withdraw consent at any time (where processing is based on consent)</li>
              <li>Right to lodge a complaint with a data protection authority</li>
            </ul>
            <p>
              To exercise your rights, please contact us at <a href="mailto:info.munchups@gmail.com">info.munchups@gmail.com</a>.
            </p>
        </section>
        <section className="privacy-section">
          <h2>8. Data Security</h2>
            <p>
              We implement appropriate technical and organizational measures to protect your personal data against unauthorized access, loss, misuse, or alteration.
            </p>
            <p>
              However, no method of transmission over the internet is completely secure, and we cannot guarantee absolute security.
            </p>
        </section>
        <section className="privacy-section">
          <h2>9. Changes to This Privacy Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated "Last updated" date.
            </p>
            <p>
              We encourage you to review this policy periodically.
            </p>
        </section>
        <div className="policy-footer">
              <p>
                By using our website, you acknowledge that you have read and understood this Privacy Policy 
                and agree to it.
              </p>
              <p>
                <strong>Last Updated: January 22, 2026</strong>
              </p>
            </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
